// extracted by mini-css-extract-plugin
export default {"container":"ToolbarColorPicker_container__kam+C","colorPickerContainer":"ToolbarColorPicker_colorPickerContainer__O-CZe"};